import { Box, Text, Image } from '@chakra-ui/react'
import type { Game } from '@olagg/db-types'
import { FC } from 'react'
import { ROUTES } from '../../routes'
import { useLocation } from 'react-router-dom'
import { cdn } from '@/utils/cloudflareCdn'

interface Props {
  game: Game,
  width?: string,
  height?: string,
  bgColor?: string,
  imageH?: string
  showRating?: boolean
  ml?: string
  mr?: string
  textColor?: string,
  showDesc?: boolean,
  showTitle?: boolean,
  loading?: 'eager' | 'lazy'
}

const GameCard: FC<Props> = ({
  game,
  width,
  height = '300px',
  bgColor = 'white',
  imageH = '233px',
  showRating = false,
  showDesc = false,
  ml = '15px',
  mr = '15px',
  textColor = '#3F2091',
  showTitle = true,
  loading = 'eager',
}) => {
  const lang = localStorage.getItem('i18n_lang') || 'es'
  const parseRating = () => game.rating?.toFixed(1) || 0

  const { pathname } = useLocation()
  const homeShadow = pathname === ROUTES.HOME ? '#00FBFF' : '#4b4b4b'

  const description = lang === 'es' ?
    game.description :
    (game.extraData?.[lang]?.description || game.description)
  return (
    <Box
      width={width}
      height={height}
      bgColor={bgColor}
      borderRadius='10px'
      marginLeft={ml}
      marginRight={mr}
      // overflow='hidden'
      display='flex'
      flexDirection='column'
      position='relative'
      overflow='hidden'
      sx={{
        transition: 'all ease 0.2s',
        '&:hover': {
          transition: 'all ease 0.2s',
          boxShadow: `0px 8px 30px 5px ${homeShadow}`,
          marginTop: '-10px',
          marginBottom: '10px',
          // transform: 'perspective(1000px) rotateY(-11.5deg) rotateX(-5.3deg)'
          transform: 'perspective(1000px) rotateY(0deg) rotateX(12.3deg)'
        }
      }}
    >
      {showRating && (
        <Box
          position='absolute'
          right='0'
          w='55px'
          h='55px'
          bgColor='#48BB78'
          borderBottomLeftRadius='10px'
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          <Text
            color="white"
            fontWeight="600"
            fontSize="24px"
          >
            {parseRating()}
          </Text>
        </Box>
      )}
      <Box>
        <Image
          loading={loading}
          w='100%'
          h={imageH}
          objectFit='cover'
          src={cdn(game.image, { h: imageH, w: '500px' })}
        />
      </Box>
      <Box
        display='flex'
        height='100%'
        padding={showDesc ? '15px 20px' : '0 20px'}
        justifyContent={showDesc ? 'inherit' : 'center'}
        flexDirection='column'
      >
        {showTitle && (
          <Text
            fontSize='24px'
            fontWeight='700'
            color={textColor}
            lineHeight='24px'
          >
            {game.title}
          </Text>
        )}
        {showDesc && (
          <Text
            fontSize='15px'
            fontWeight='500'
            color={textColor}
            lineHeight='150%'
            marginTop='5px'
          >
            {description}
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default GameCard
